import React from 'react';
import Head from 'next/head';
import BMaps from '~/components/BMap/BMap/';
import css from './LayerD.less';

const closeIcon = require('~/static/common/close.png');

class LayerD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this._isMounted = true;
    window.addEventListener('keydown', event => {
      const e = event || window.event;
      const { hideLayer } = this.props;
      if (e && e.keyCode === 27 && this._isMounted) {
        hideLayer();
      }
    });
    window.BMAP_PROTOCOL = 'https';
    window.BMap_loadScriptTime = new Date().getTime();
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('keydown', () => {
      return false;
    });
  }

  // eslint-disable-next-line
  handleClick(event) {
    const e = event || window.event;
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      e.cancaleBubble = true;
    }
  }

  render() {
    const { visible, hideLayer, address } = this.props;
    return (
      // eslint-disable-next-line
      <div
        className={`${css.layer} ${visible ? css.show : ''}`}
        onClick={hideLayer}
      >
        <Head>
          {/* 强制百度地图使用 https, via: https://juejin.im/post/5a9259ef5188251c85637e25 */}
          <script type="text/javascript">window.HOST_TYPE = 2</script>
          <script
            type="text/javascript"
            src="https://api.map.baidu.com/getscript?v=3.0&ak=Y9jgxivheqPfxYLZTHjDr8wTVFbO5bYG&services=&t=20191018171908&s=1"
          >
            {' '}
          </script>
        </Head>
        <button className={css.clear} type="button" onClick={hideLayer}>
          <img src={closeIcon} alt="close" className={css.close} />
        </button>
        {/* eslint-disable-next-line */}
        <div
          className={`flex-column-center ${css.main}`}
          onClick={e => this.handleClick(e)}
        >
          {visible ? <BMaps address={address} /> : null}
        </div>
      </div>
    );
  }
}

export default LayerD;
